// This React component, FaqAmplience, renders a Frequently Asked Questions (FAQ) section using the provided faqContent prop.
// It utilizes a responsive layout with Tailwind CSS for styling and maps through the FAQ data to dynamically create an
// accordion for each question and answer pair. The AccordionBtn component is used for collapsible sections, while
// MarkDownDescription renders answers with markdown support. If no FAQs are available, a fallback message is displayed
// using the useFormat hook for internationalization. The design ensures scalability and responsiveness for various screen sizes.

import React, { useEffect, useState } from 'react';
import { Category } from 'shared/types/product';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';
import { useFormat } from 'helpers/hooks/useFormat';
import { FrequentlyAskedQuestions } from '../../../product-list-algolia/types';
import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';
interface FAQProps {
  faqContent: FrequentlyAskedQuestions;
}
interface PLPFAQ {
  question: string;
  answer: string;
}

const FaqAmplience: React.FC<FAQProps> = ({ faqContent }) => {
  const { formatMessage } = useFormat({ name: 'common' });

  return (
    <div className="flex justify-center px-4 py-10 sm:px-6 lg:px-8">
      <div className="md:w-[1140px]">
        <div className="my-20 text-center">
          <h3 className="text-lg font-bold leading-10 text-gray-700 sm:text-[36px]">{faqContent?.overallTitle}</h3>
        </div>
        <hr></hr>
        {faqContent?.questions?.length > 0 ? (
          faqContent?.questions?.map((faq: PLPFAQ, index) => (
            <div key={index} className="">
              <AccordionBtn
                variant="plusAndMinus"
                className="col-span-2 mt-6 border-b border-neutral-400 px-30 py-22 font-semibold"
                closedSectionTitle={faq?.question}
                buttonClassName="py-4 font-body text-base sm:text-lg md:text-xl leading-tight text-primary-black pl-0 md:pr-12"
                panelClassName="pb-4 md:pt-2 md:pb-6 text-primary-black"
              >
                <MarkDownDescription markdownText={faq?.answer} classname="" />
              </AccordionBtn>
            </div>
          ))
        ) : (
          <p className="text-center text-lg text-gray-500 sm:text-xl md:text-2xl">
            {formatMessage({ id: 'FaqNotAvailable', defaultMessage: 'FAQs are not available.' })}
          </p>
        )}
      </div>
    </div>
  );
};

export default FaqAmplience;
